"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKModalBody = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../../common");
var components_1 = require("../../../components");
/**
 * Body of a simple modal dialog container.
 * Also supplies the alerts container for the modal.
 *
 * @remarks
 * See the Reactstrap docs for Modals: https://reactstrap.github.io/components/modals/
 */
var GKModalBody = function (props) {
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-modal-body",
    }), alertsOverlay = _a.alertsOverlay, children = _a.children, qaTag = _a["data-qa"], 
    // Intentionally destructured from mergedProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    useAlertsLocalStyle = _a.useAlertsLocalStyle, mergedProps = __rest(_a, ["alertsOverlay", "children", "data-qa", "useAlertsLocalStyle"]);
    var alertContainerClass = alertsOverlay
        ? "alerts-overlay"
        : "alerts-inline";
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { key: "alert-area", "aria-hidden": "true", className: "gk-modal-alerts" },
            React.createElement(components_1.GKContextualAlerts, { "data-qa": qaTag + "--alerts", global: true, className: alertContainerClass })),
        React.createElement(reactstrap_1.ModalBody, __assign({ "data-qa": qaTag }, mergedProps), children)));
};
exports.GKModalBody = GKModalBody;
exports.default = exports.GKModalBody;
